import { useMemo } from 'react';

import { useGraphQuery } from '@/hooks/useGraphQuery';
import { GraphQuery, QueryFilter } from '@/types';

interface UseKEVVulnerabilitiesProps {
  search?: string;
  limit?: number;
  page?: number;
  kevFilter?: boolean;
}

export const useKEVVulnerabilities = ({
  search = '',
  limit = 100,
  page = 0,
  kevFilter,
}: UseKEVVulnerabilitiesProps = {}) => {
  const trimmedSearch = search.trim();

  const filters: QueryFilter[] = useMemo(() => {
    const baseFilters: QueryFilter[] = [];

    if (kevFilter !== undefined) {
      baseFilters.push({
        field: 'kev',
        operator: '=',
        value: kevFilter,
      });
    }

    return baseFilters;
  }, [trimmedSearch, kevFilter]);

  const query: GraphQuery = useMemo(
    () => ({
      node: {
        labels: ['Vulnerability'],
        filters,
        // Fulltext search — covers key, id, title, data via vulnerabilitySearchIndex
        ...(trimmedSearch && trimmedSearch.length >= 2
          ? { search: trimmedSearch }
          : {}),
      },
      limit,
      page,
      orderBy: 'created',
      descending: true,
    }),
    [filters, limit, page, trimmedSearch]
  );

  return useGraphQuery({ query, enabled: true });
};
